import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { Params } from "@/types/api";

type CountRequest = {
  // Consumers pass the route-derived org id, which can be null before an org
  // is resolved; mirrors the previously-untyped Vuex action contract.
  organisationId: string | null;
  params: Params;
};

export const useHistoryStore = defineStore("history", () => {
  const totalEmailsAnalyzed = ref<number>(0);
  const totalIncidents = ref<number>(0);

  const setTotalEmailsAnalyzed = (count: number): void => {
    totalEmailsAnalyzed.value = count;
  };

  const setTotalIncidents = (count: number): void => {
    totalIncidents.value = count;
  };

  const getTotalEmailsAnalyzed = async ({
    organisationId,
    params,
  }: CountRequest): Promise<void> => {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get<{ count: number }>(
      `${getApiClientUrl()}/v3/pt/history/${organisationId}/messages/count?${filterParams.toString()}`,
    );

    setTotalEmailsAnalyzed(res.data.count);
  };

  const getTotalIncidents = async ({
    organisationId,
    params,
  }: CountRequest): Promise<void> => {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get<{ count: number }>(
      `${getApiClientUrl()}/v3/pt/history/${organisationId}/incidents/count?${filterParams.toString()}`,
    );

    setTotalIncidents(res.data.count);
  };

  return {
    totalEmailsAnalyzed,
    totalIncidents,
    setTotalEmailsAnalyzed,
    setTotalIncidents,
    getTotalEmailsAnalyzed,
    getTotalIncidents,
  };
});
